import React, { Fragment } from "react";

import { splitTextByLinks } from "@emeria/shared-text-links";

import { ExternalLink } from "../ExternalLink";

type TextWithLinksProps = { text: string };

export function TextWithLinks({ text }: TextWithLinksProps): React.JSX.Element {
  return (
    <>
      {splitTextByLinks(text).map((segment) =>
        segment.type === "link" ? (
          <ExternalLink key={segment.start} href={segment.href}>
            {segment.text}
          </ExternalLink>
        ) : (
          <Fragment key={segment.start}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
